import { useState } from "react";
import User from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/User";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import UserService from "../services/UserService";

const useUserInfo = () => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const [opsUser, setOpsUser] = useState<EnsolversOpsUser | undefined>(undefined);

  const updateLoggedUser = async (loggedUser: User | undefined) => {

    setUser(loggedUser);
    if (loggedUser) {
      setOpsUser((await UserService.findByCoreUserId(loggedUser.externalId!)).getContentOrThrowError());
    } else{
      setOpsUser(undefined);
    }
  }

  const isUserLoaded = () => {
    return user !== undefined;
  }

  return {
    user,
    opsUser,
    isUserLoaded,
    updateLoggedUser
  }
}

export default useUserInfo;